import IncidentPanel from './IncidentPanel';

export default IncidentPanel;
